/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getEmails = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Email query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-email-info/get?${queryString}`);
};

export const getEmailByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-email-info/${id}`);
};

export const getEmailByMID = (mid) => {
  return API.get(`${getApiUrl()}/api/tkt1-email-info/mid/${mid}`);
};

export const createEmail = (emailData) => {
  return API.post(`${getApiUrl()}/api/tkt1-email-info/`, emailData);
};

export const updateEmail = (id, emailData) => {
  return API.put(`${getApiUrl()}/api/tkt1-email-info/${id}`, emailData);
};

export const updateEmailByMID = (mid, emailData) => {
  return API.put(`${getApiUrl()}/api/tkt1-email-info/mid/${mid}`, emailData);
};

export const deleteEmail = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-email-info/${id}`);
};

export const tkt1EmailService = {
  getEmails,
  getEmailByID,
  getEmailByMID,
  createEmail,
  updateEmail,
  updateEmailByMID,
  deleteEmail
};